module.exports = __webpack_public_path__ + "img/4_8.0c73600b.png";